<template>
  <div id="app">
    <router-view :key="$route.query.code || $route.query.payMethod" />
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted () {
    // this.bodyScale()
    // let self = this
    // window.onload = window.onresize = function () {
    //   self.bodyScale()
    // }
    this.$nextTick(() => {
      document.oncontextmenu = function (event) {
        event.preventDefault()
      }
      document.addEventListener('keydown', function (e) {
        if (e.key === 'F12') {
          e.preventDefault()
        }
      })
    })
  },
  methods: {
    // bodyScale () {
    //   var devicewidth = document.documentElement.clientWidth
    //   var scale = devicewidth / 1920
    //   document.body.style.zoom = scale
    // }
  }
}
</script>

<style>
#app {
  height: 100%;
  font-family: PuHuiTi-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
  font-size: 16px;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.3);
  border-radius: 5px;
  border: 1px solid transparent;
  height: 140px;
  background-clip: content-box;
}
</style>
